import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Cài đặt thủ tục nhập học", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-5" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header border-0 pt-2" }
const _hoisted_14 = { class: "card-title d-block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 mb-1 mt-5" }, "Danh sách học bổng", -1)
const _hoisted_16 = { class: "text-muted fs-8 fst-italic mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "học phí toàn khóa của ngành", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "tỷ lệ", -1)
const _hoisted_19 = { class: "card-toolbar" }
const _hoisted_20 = {
  class: "justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_21 = { class: "svg-icon svg-icon-2" }
const _hoisted_22 = { class: "svg-icon svg-icon-2" }
const _hoisted_23 = {
  type: "button",
  class: "btn btn-sm btn-light-primary d-none",
  "data-bs-toggle": "modal",
  ref: "kt_modal_add_combination",
  "data-bs-target": "#kt_modal_add_combination"
}
const _hoisted_24 = { class: "card-body umt-form pt-0" }
const _hoisted_25 = { class: "fw-semibold text-gray-800" }
const _hoisted_26 = { class: "d-flex align-items-center gap-2 mt-1" }
const _hoisted_27 = { class: "text-muted fs-8" }
const _hoisted_28 = {
  key: 0,
  class: "badge badge-light-danger fs-9",
  title: "Đang tắt Kích hoạt — không chọn/áp mới vào học phí được nữa"
}
const _hoisted_29 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_30 = {
  key: 0,
  class: "badge badge-light-warning fs-9",
  title: "Nhân viên thường không thấy học bổng này khi cấp/đăng ký"
}
const _hoisted_31 = {
  key: 1,
  class: "badge badge-light-primary fs-9",
  title: "Luôn cho chọn ở mục Thông tin học phí, không cần thỏa điều kiện kích hoạt"
}
const _hoisted_32 = {
  key: 2,
  class: "badge badge-light-info fs-9",
  title: "Cổng sinh viên không tự chọn được, chỉ xem khi đã được cấp"
}
const _hoisted_33 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_34 = { class: "badge badge-light fs-8" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = {
  key: 0,
  class: "badge badge-light-primary fs-8"
}
const _hoisted_38 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_39 = { class: "text-end fw-semibold text-gray-800" }
const _hoisted_40 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_41 = {
  key: 0,
  class: "badge badge-light-info fs-9",
  title: "Chỉ áp dụng khi thỏa điều kiện kích hoạt"
}
const _hoisted_42 = ["title"]
const _hoisted_43 = {
  key: 2,
  class: "badge badge-light-primary fs-9",
  title: "Giảm thêm theo số học kỳ đóng trước"
}
const _hoisted_44 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_45 = ["title"]
const _hoisted_46 = { class: "d-flex flex-center gap-5" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":".7"}
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  class: "svg-icon svg-icon-2 svg-icon-danger",
  style: {"opacity":".6"}
}
const _hoisted_51 = {
  class: "modal fade umt-form",
  id: "kt_modal_add_combination",
  ref: "addCombinationModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_55 = { class: "fw-bolder" }
const _hoisted_56 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_57 = { class: "svg-icon svg-icon-1" }
const _hoisted_58 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_59 = { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "1", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Thông tin học bổng", -1)
const _hoisted_62 = { class: "ms-auto d-flex align-items-center gap-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "umt-flag-divider mx-2" }, null, -1)
const _hoisted_64 = { class: "d-flex align-items-center gap-2" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", {
  class: "form-label fw-bolder mb-0 text-nowrap",
  title: "Tắt = học bổng không còn được chọn/áp mới vào học phí (hồ sơ đã áp vẫn giữ nguyên)"
}, "Kích hoạt", -1)
const _hoisted_66 = { class: "row g-3" }
const _hoisted_67 = { class: "col-md-5 col-12" }
const _hoisted_68 = { class: "fv-row flex-md-root" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Tên học bổng", -1)
const _hoisted_70 = { class: "col-md-3 col-12" }
const _hoisted_71 = { class: "fv-row flex-md-root" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Code", -1)
const _hoisted_73 = { class: "col-md-4 col-12" }
const _hoisted_74 = { class: "fv-row flex-md-root" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Loại", -1)
const _hoisted_76 = { class: "col-md-4 col-12" }
const _hoisted_77 = { class: "fv-row flex-md-root" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Chương trình", -1)
const _hoisted_79 = { class: "col-md-4 col-12" }
const _hoisted_80 = { class: "fv-row flex-md-root" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Số học kỳ cấp", -1)
const _hoisted_82 = { class: "col-md-4 col-12" }
const _hoisted_83 = { class: "fv-row flex-md-root" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, [
  /*#__PURE__*/_createTextVNode("Tỉ lệ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(0.5 = giảm 50%)")
], -1)
const _hoisted_85 = {
  key: 0,
  class: "text-muted fs-8 mt-1 fst-italic"
}
const _hoisted_86 = { class: "col-md-4 col-12" }
const _hoisted_87 = { class: "fv-row flex-md-root" }
const _hoisted_88 = { class: "d-flex align-items-center gap-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder mb-0" }, [
  /*#__PURE__*/_createTextVNode("Giá trị "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(tổng tiền học bổng)")
], -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", {
  class: "btn btn-icon btn-sm btn-light-primary w-25px h-25px",
  title: "Tính thử từ học phí một ngành"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calculator fs-7" })
], -1)
const _hoisted_91 = { class: "fs-7" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-1" }, "Tính thử từ học phí", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mb-3" }, "Mỗi ngành một mức học phí — chọn 1 ngành làm gốc để ra con số gợi ý. Ngành chọn ở đây KHÔNG lưu vào học bổng.", -1)
const _hoisted_94 = {
  key: 0,
  class: "fs-8 text-gray-700 mb-3"
}
const _hoisted_95 = { class: "fw-bolder text-primary fs-7" }
const _hoisted_96 = {
  key: 1,
  class: "fs-8 text-muted fst-italic mb-3"
}
const _hoisted_97 = ["disabled"]
const _hoisted_98 = { class: "col-md-8 col-12" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Mô tả", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_101 = { class: "d-flex align-items-center gap-2 pb-2 border-bottom border-gray-200" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "2", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", {
  class: "cursor-pointer fw-bolder fs-6 text-gray-600 text-uppercase mb-0",
  for: "isCondition"
}, "Điều kiện kích hoạt", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal fst-italic" }, "— chỉ áp dụng học bổng khi thỏa điều kiện (vd đóng phí giữ suất trước hạn)", -1)
const _hoisted_105 = {
  key: 0,
  class: "row g-3 mb-2 mt-1 ps-5 align-items-start"
}
const _hoisted_106 = { class: "col-md-4 col-12" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Thời gian", -1)
const _hoisted_108 = { class: "col-md-4 col-6" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Loại", -1)
const _hoisted_110 = { class: "col-md-4 col-6" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Giá trị", -1)
const _hoisted_112 = { class: "col-12" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mô tả", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_115 = { class: "d-flex align-items-center gap-2 pb-2 border-bottom border-gray-200 mb-3" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle bg-primary fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "3", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", {
  class: "cursor-pointer fw-bolder fs-6 text-primary text-uppercase mb-0",
  for: "isAddition"
}, "Ưu đãi cộng thêm", -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal fst-italic" }, "— các khoản giảm trừ đi kèm khi nhận học bổng này", -1)
const _hoisted_119 = { key: 1 }
const _hoisted_120 = { class: "d-flex align-items-center gap-2 mb-3" }
const _hoisted_121 = { class: "badge badge-circle bg-primary" }
const _hoisted_122 = { class: "fs-7 fw-bolder text-gray-700" }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-6" }, null, -1)
const _hoisted_125 = [
  _hoisted_124
]
const _hoisted_126 = { class: "d-flex gap-2 flex-center w-100" }
const _hoisted_127 = { class: "row g-3 w-100" }
const _hoisted_128 = { class: "col-md-4 col-12" }
const _hoisted_129 = { class: "fv-row" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tên Ưu đãi", -1)
const _hoisted_131 = { class: "col-md-4 col-8" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Giá trị", -1)
const _hoisted_133 = { class: "col-md-4 col-4" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  title: "isExtend — ưu đãi này được cộng dồn với ưu đãi khác"
}, "Cộng dồn", -1)
const _hoisted_135 = { class: "col-12" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mô tả", -1)
const _hoisted_137 = ["onUpdate:modelValue"]
const _hoisted_138 = { class: "col-12 bg-light rounded border-gray-300 border border-dashed p-3" }
const _hoisted_139 = { class: "d-flex align-items-center mb-2" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 fw-bolder text-gray-600 text-uppercase" }, "Điều kiện kích hoạt", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic ms-2" }, "— phải thỏa TẤT CẢ mới được ưu đãi", -1)
const _hoisted_142 = ["onClick"]
const _hoisted_143 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle text-primary me-1" }, null, -1)
const _hoisted_144 = { class: "d-flex align-items-center mb-2" }
const _hoisted_145 = { class: "fs-8 fw-bolder text-gray-600" }
const _hoisted_146 = ["onClick"]
const _hoisted_147 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg fs-7" }, null, -1)
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = { class: "row g-3 align-items-start" }
const _hoisted_150 = { class: "col-md-4 col-12" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Thời gian", -1)
const _hoisted_152 = { class: "col-md-4 col-6" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Loại", -1)
const _hoisted_154 = { class: "col-md-4 col-6" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Giá trị", -1)
const _hoisted_156 = { class: "col-12" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mô tả", -1)
const _hoisted_158 = ["onUpdate:modelValue"]
const _hoisted_159 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle bg-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-3 p-0 m-0" })
], -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_161 = { class: "d-flex align-items-center gap-2 pb-2 border-bottom border-gray-200 mb-3" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle bg-primary fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "4", -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("label", {
  class: "cursor-pointer fw-bolder fs-6 text-primary text-uppercase mb-0",
  for: "ismultibuy"
}, "Multibuy", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal fst-italic" }, "— giảm thêm theo số học kỳ đóng trước", -1)
const _hoisted_165 = {
  key: 2,
  class: "border border-primary border-dashed rounded bg-light-primary p-4"
}
const _hoisted_166 = { class: "fv-row mb-4" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Tên chương trình Multibuy", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-1 fst-italic" }, "Tên chung hiển thị cho cả nhóm mức bên dưới", -1)
const _hoisted_169 = { class: "d-flex align-items-center mb-2" }
const _hoisted_170 = { class: "fs-8 fw-bolder text-gray-600" }
const _hoisted_171 = ["onClick"]
const _hoisted_172 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg fs-7" }, null, -1)
const _hoisted_173 = [
  _hoisted_172
]
const _hoisted_174 = { class: "row g-3 align-items-start" }
const _hoisted_175 = { class: "col-12" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Tên mức "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(để trống sẽ dùng tên chương trình)")
], -1)
const _hoisted_177 = { class: "col-md-4 col-12" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label required",
  title: "Min. Semester"
}, "Đóng từ (học kỳ)", -1)
const _hoisted_179 = { class: "col-md-4 col-6" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label required",
  title: "Discount type"
}, "Kiểu giảm", -1)
const _hoisted_181 = { class: "col-md-4 col-6" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label required",
  title: "Disc. % / Disc. Amount"
}, "Mức giảm", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle bg-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-3 p-0 m-0" })
], -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-3" }, null, -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end gap-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32",
    "data-bs-dismiss": "modal"
  }, "Hủy"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-1" }),
    /*#__PURE__*/_createTextVNode("Lưu ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
          ]),
          _hoisted_9,
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/caidatthutucnhaphoc",
              class: "text-muted text-hover-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cài đặt thủ tục nhập học ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_11,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(" Khi duyệt học bổng, số tiền cấp = "),
              _hoisted_17,
              _createTextVNode(" × "),
              _hoisted_18,
              _createTextVNode(" bên dưới — "),
              _createVNode(_component_router_link, {
                to: "/caidatthutucnhaphoc/hocphi",
                class: "text-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("xem biểu học phí")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "btn btn-success me-3",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportFile && _ctx.exportFile(...args)))
              }, [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                ]),
                _createTextVNode(" Xuất Excel ")
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.callModalAddApp && _ctx.callModalAddApp(...args)))
              }, [
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm học bổng ")
              ]),
              _createElementVNode("button", _hoisted_23, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            total: _ctx.tableData.length,
            currentPage: _ctx.pagination.currentPage,
            "table-header": _ctx.tableHeader,
            "rows-per-page": _ctx.pagination.limit,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-name": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: _normalizeClass(customer.isactive === false ? 'opacity-50' : '')
              }, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(customer.name), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(customer.type || customer.code || '—'), 1),
                  (customer.isactive === false)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Ngưng"))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]),
            "cell-scope": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_29, [
                (customer.leaderonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Trưởng nhóm"))
                  : _createCommentVNode("", true),
                (customer.bypasscondition)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Bỏ qua ĐK"))
                  : _createCommentVNode("", true),
                (customer.adminonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Chỉ admin"))
                  : _createCommentVNode("", true),
                (!customer.leaderonly && !customer.bypasscondition && !customer.adminonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "—"))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell-programtype": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.optionsPrograms.find(i => i.value == customer.programtype)?.label || '—'), 1)
              ])
            ]),
            "cell-releasedIn": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", null, _toDisplayString(customer.releasedIn ? customer.releasedIn + ' HK' : '—'), 1)
              ])
            ]),
            "cell-rate": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_36, [
                (customer.rate != null && customer.rate !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(isNaN(+customer.rate) ? customer.rate : Math.round(+customer.rate * 100) + '%'), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, "—"))
              ])
            ]),
            "cell-value": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("span", null, _toDisplayString(customer.value ? customer.value.toLocaleString('vi-VN') : '—'), 1)
              ])
            ]),
            "cell-extras": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_40, [
                (customer.condition)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Điều kiện"))
                  : _createCommentVNode("", true),
                (customer.addition?.length)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "badge badge-light-success fs-9",
                      title: customer.addition.map(a => a.name).join(', ')
                    }, " Ưu đãi (" + _toDisplayString(customer.addition.length) + ") ", 9, _hoisted_42))
                  : _createCommentVNode("", true),
                (customer.benefitaddition?.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, " Multibuy (" + _toDisplayString(customer.benefitaddition.length) + ") ", 1))
                  : _createCommentVNode("", true),
                (!customer.condition && !customer.addition?.length && !customer.benefitaddition?.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "—"))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell-description": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: "text-muted text-truncate mw-250px",
                title: customer.description
              }, _toDisplayString(customer.description || '—'), 9, _hoisted_45)
            ]),
            "cell-actions": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("span", {
                  onClick: ($event: any) => (_ctx.setDataForm(customer)),
                  class: "menu-link cursor-pointer"
                }, [
                  _createElementVNode("span", _hoisted_48, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen58.svg" })
                  ])
                ], 8, _hoisted_47),
                _createElementVNode("span", {
                  class: "menu-link cursor-pointer",
                  onClick: ($event: any) => (_ctx.deleteRow(customer))
                }, [
                  _createElementVNode("span", _hoisted_50, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/remove-file.svg" })
                  ])
                ], 8, _hoisted_49)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("h2", _hoisted_55, _toDisplayString(_ctx.isEdit ? "Chỉnh sửa học bổng" : "Thêm học bổng"), 1),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("span", _hoisted_57, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              ref: "formRef",
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_el_checkbox, {
                        class: "umt-flag-chip",
                        modelValue: _ctx.formData.leaderonly,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.leaderonly) = $event)),
                        label: "Chỉ trưởng nhóm",
                        title: "Nhân viên thường không thấy học bổng này khi cấp/đăng ký"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        class: "umt-flag-chip",
                        modelValue: _ctx.formData.bypasscondition,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.bypasscondition) = $event)),
                        label: "Bỏ qua điều kiện",
                        title: "Luôn cho chọn ở mục Thông tin học phí, không cần thỏa Điều kiện kích hoạt bên dưới"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        class: "umt-flag-chip",
                        modelValue: _ctx.formData.adminonly,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.adminonly) = $event)),
                        label: "Chỉ admin chọn",
                        title: "Cổng sinh viên không tự chọn được; chỉ xem sau khi tư vấn viên đã áp dụng"
                      }, null, 8, ["modelValue"]),
                      _hoisted_63,
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_el_switch, {
                          class: "el-switch",
                          modelValue: _ctx.formData.isactive,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.isactive) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_65
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createVNode(_component_el_form_item, { prop: "name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "form-select-solid w-100",
                              placeholder: "Tên học bổng",
                              modelValue: _ctx.formData.name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.name) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createVNode(_component_el_form_item, { prop: "code" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "form-select-solid w-100",
                              placeholder: "Code",
                              modelValue: _ctx.formData.code,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.code) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createVNode(_component_el_form_item, { prop: "name" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              disabled: _ctx.isEdit,
                              class: "form-select-solid w-100",
                              placeholder: "Loại học bổng",
                              modelValue: _ctx.formData.type,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.type) = $event))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode(_component_el_form_item, { prop: "code" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              modelValue: _ctx.formData.programtype,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.programtype) = $event)),
                              "reserve-keyword": false,
                              class: "form-select-solid w-100",
                              placeholder: "Chương trình"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsPrograms, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createVNode(_component_el_form_item, { prop: "releasedIn" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "form-select-solid w-100",
                              placeholder: "VD: 11",
                              modelValue: _ctx.formData.releasedIn,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.releasedIn) = $event)),
                              modelModifiers: { number: true }
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createVNode(_component_el_input, {
                          class: "form-select-solid w-100",
                          onKeypress: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isNumber($event))),
                          placeholder: "VD: 0.5",
                          modelValue: _ctx.formData.rate,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.rate) = $event))
                        }, null, 8, ["modelValue"]),
                        (_ctx.formData.rate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, " = giảm " + _toDisplayString(isNaN(+_ctx.formData.rate) ? _ctx.formData.rate : Math.round(+_ctx.formData.rate * 100) + '%') + " học phí toàn khóa ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _hoisted_89,
                          _createVNode(_component_el_popover, {
                            placement: "bottom-start",
                            width: 360,
                            trigger: "click"
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_90
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_91, [
                                _hoisted_92,
                                _hoisted_93,
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.calcTuitionId,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.calcTuitionId) = $event)),
                                  "popper-class": "umt-form-dd",
                                  filterable: "",
                                  clearable: "",
                                  "popper-append-to-body": false,
                                  class: "form-select-solid w-100 mb-3",
                                  placeholder: "Chọn ngành"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tuitionOptions(), (t) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: t.id,
                                        label: `${t.majorName} — ${t.wholeCourseFee.toLocaleString('vi-VN')}`,
                                        value: t.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (_ctx.calcSuggestValue())
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                      _createTextVNode(_toDisplayString(_ctx.calcTuition().wholeCourseFee.toLocaleString('vi-VN')) + " × " + _toDisplayString(Math.round(+_ctx.formData.rate * 100)) + "% = ", 1),
                                      _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.calcSuggestValue().toLocaleString('vi-VN')), 1)
                                    ]))
                                  : (_ctx.calcTuitionId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, "Nhập Tỉ lệ ở trên để ra số."))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-primary w-100",
                                  disabled: !_ctx.calcSuggestValue(),
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.applySuggestValue()))
                                }, "Dùng số này", 8, _hoisted_97)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_form_item, { prop: "value" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "form-select-solid w-100",
                              placeholder: "VD: 191.750.000",
                              modelValue: _ctx.formData.value,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.value) = $event)),
                              onKeypress: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isNumber($event))),
                              onKeyup: _cache[18] || (_cache[18] = e=> {
                                                    _ctx.formData.value = _ctx.formatCurrentMoney(e,_ctx.formData.value)
                                                })
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_98, [
                      _hoisted_99,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-textarea w-100",
                        rows: "2",
                        placeholder: "Mô tả ngắn hiển thị khi chọn học bổng",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.description) = $event))
                      }, "\n                                    ", 512), [
                        [_vModelText, _ctx.formData.description]
                      ])
                    ])
                  ]),
                  _hoisted_100,
                  _createElementVNode("div", _hoisted_101, [
                    _hoisted_102,
                    _withDirectives(_createElementVNode("input", {
                      id: "isCondition",
                      class: "opacity-0 d-none",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.isCondition) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.isCondition]
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "isCondition",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.formData.isCondition,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.isCondition) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_103,
                    _hoisted_104
                  ]),
                  (_ctx.formData.isCondition)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _hoisted_107,
                          _createVNode(_component_el_date_picker, {
                            class: "el-date-picker w-100",
                            modelValue: _ctx.formData.condition.date,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.condition.date) = $event)),
                            placeholder: "Thời gian",
                            format: "DD/MM/YYYY"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _hoisted_109,
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            modelValue: _ctx.formData.condition.type,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.condition.type) = $event)),
                            "reserve-keyword": false,
                            class: "form-select-solid w-100",
                            placeholder: "Chọn loại"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsType, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_110, [
                          _hoisted_111,
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "Giá trị",
                            modelValue: _ctx.formData.condition.value,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.condition.value) = $event)),
                            onKeypress: _cache[25] || (_cache[25] = ($event: any) => (_ctx.isNumber($event))),
                            onKeyup: _cache[26] || (_cache[26] = e=> {
                                                    _ctx.formData.condition.value = _ctx.formatCurrentMoney(e,_ctx.formData.condition.value)
                                                })
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _hoisted_113,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-textarea w-100",
                            rows: "2",
                            placeholder: "Mô tả",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.condition.description) = $event))
                          }, "\n                                    ", 512), [
                            [_vModelText, _ctx.formData.condition.description]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_114,
                  _createElementVNode("div", _hoisted_115, [
                    _hoisted_116,
                    _withDirectives(_createElementVNode("input", {
                      id: "isAddition",
                      class: "opacity-0 d-none",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.isAddition) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.formData.isAddition]
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "isAddition",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.formData.isAddition,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.isAddition) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_117,
                    _hoisted_118
                  ]),
                  (_ctx.formData.isAddition)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPromotion, (row, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "border border-primary border-dashed rounded bg-light-primary p-4 mb-3"
                          }, [
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("span", _hoisted_121, _toDisplayString(index+1), 1),
                              _createElementVNode("span", _hoisted_122, "Ưu đãi " + _toDisplayString(index+1), 1),
                              (index != 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    title: "Xóa ưu đãi này",
                                    class: "btn btn-sm btn-icon btn-light-danger ms-auto",
                                    onClick: ($event: any) => (_ctx.removeRowScholar(index))
                                  }, _hoisted_125, 8, _hoisted_123))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("div", _hoisted_127, [
                                _createElementVNode("div", _hoisted_128, [
                                  _createElementVNode("div", _hoisted_129, [
                                    _hoisted_130,
                                    _createVNode(_component_el_input, {
                                      class: "form-select-solid w-100",
                                      placeholder: "Tên Ưu đãi",
                                      modelValue: row.name,
                                      "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_131, [
                                  _hoisted_132,
                                  _createVNode(_component_el_input, {
                                    class: "form-select-solid w-100",
                                    placeholder: "Giá trị",
                                    modelValue: row.value,
                                    "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                                    onKeypress: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isNumber($event))),
                                    onKeyup: e=> {
                                                                    row.value = _ctx.formatCurrentMoney(e,row.value)
                                                                }
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                ]),
                                _createElementVNode("div", _hoisted_133, [
                                  _hoisted_134,
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_el_checkbox, {
                                      modelValue: row.isExtend,
                                      "onUpdate:modelValue": ($event: any) => ((row.isExtend) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_135, [
                                  _hoisted_136,
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "form-textarea w-100",
                                    rows: "2",
                                    placeholder: "Mô tả",
                                    "onUpdate:modelValue": ($event: any) => ((row.description) = $event)
                                  }, "\n                                                    ", 8, _hoisted_137), [
                                    [_vModelText, row.description]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_138, [
                                  _createElementVNode("div", _hoisted_139, [
                                    _hoisted_140,
                                    _hoisted_141,
                                    _createElementVNode("span", {
                                      class: "cursor-pointer text-primary fs-8 fw-semibold ms-auto",
                                      onClick: ($event: any) => (_ctx.addCondition(index))
                                    }, [
                                      _hoisted_143,
                                      _createTextVNode("Thêm điều kiện ")
                                    ], 8, _hoisted_142)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.condition, (con, ind) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "bg-white rounded border border-gray-200 p-3 mb-2",
                                      key: ind
                                    }, [
                                      _createElementVNode("div", _hoisted_144, [
                                        _createElementVNode("span", _hoisted_145, _toDisplayString(ind == 0 ? 'Điều kiện 1' : 'VÀ điều kiện ' + (ind + 1)), 1),
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.removeRowCondition(index,ind)),
                                          type: "button",
                                          title: "Xóa điều kiện này",
                                          class: "btn btn-sm btn-icon btn-light-danger ms-auto"
                                        }, _hoisted_148, 8, _hoisted_146)
                                      ]),
                                      _createElementVNode("div", _hoisted_149, [
                                        _createElementVNode("div", _hoisted_150, [
                                          _hoisted_151,
                                          _createVNode(_component_el_date_picker, {
                                            class: "el-date-picker w-100",
                                            modelValue: con.date,
                                            "onUpdate:modelValue": ($event: any) => ((con.date) = $event),
                                            placeholder: "Thời gian",
                                            format: "DD/MM/YYYY"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_152, [
                                          _hoisted_153,
                                          _createVNode(_component_el_select, {
                                            "popper-class": "umt-form-dd",
                                            modelValue: con.type,
                                            "onUpdate:modelValue": ($event: any) => ((con.type) = $event),
                                            "reserve-keyword": false,
                                            class: "form-select-solid w-100",
                                            placeholder: "Chọn loại"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsType, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_154, [
                                          _hoisted_155,
                                          _createVNode(_component_el_input, {
                                            class: "form-select-solid w-100",
                                            placeholder: "Giá trị",
                                            modelValue: con.value,
                                            "onUpdate:modelValue": ($event: any) => ((con.value) = $event),
                                            onKeypress: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isNumber($event))),
                                            onKeyup: e=> {
                                                                            con.value = _ctx.formatCurrentMoney(e,con.value)
                                                                        }
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                        ]),
                                        _createElementVNode("div", _hoisted_156, [
                                          _hoisted_157,
                                          _withDirectives(_createElementVNode("textarea", {
                                            class: "form-textarea w-100",
                                            rows: "2",
                                            placeholder: "Mô tả",
                                            "onUpdate:modelValue": ($event: any) => ((con.description) = $event)
                                          }, "\n                                                            ", 8, _hoisted_158), [
                                            [_vModelText, con.description]
                                          ])
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.addNewRow && _ctx.addNewRow(...args))),
                          class: "me-auto btn btn-sm btn-link d-flex gap-2 align-items-center text-primary"
                        }, [
                          _hoisted_159,
                          _createTextVNode(" Thêm ưu đãi")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_160,
                  _createElementVNode("div", _hoisted_161, [
                    _hoisted_162,
                    _withDirectives(_createElementVNode("input", {
                      id: "ismultibuy",
                      onChange: _cache[33] || (_cache[33] = e=>_ctx.funcChangeMultiBuy(e.target?.checked)),
                      class: "opacity-0 d-none",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.ismultibuy) = $event))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.formData.ismultibuy]
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "ismultibuy",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          onChange: _ctx.funcChangeMultiBuy,
                          modelValue: _ctx.formData.ismultibuy,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.ismultibuy) = $event))
                        }, null, 8, ["onChange", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_163,
                    _hoisted_164
                  ]),
                  (_ctx.formData.ismultibuy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                        _createElementVNode("div", _hoisted_166, [
                          _hoisted_167,
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "VD: Ưu đãi đóng trước nhiều học kỳ",
                            modelValue: _ctx.formData.namemultibuy,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.namemultibuy) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_168
                        ]),
                        (_ctx.formData.benefitaddition && _ctx.formData.benefitaddition.length != 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.benefitaddition, (fill, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["rounded border border-gray-200 p-3 mb-2", index % 2 ? 'bg-light' : 'bg-white']),
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_169, [
                                  _createElementVNode("span", _hoisted_170, "Mức " + _toDisplayString(index + 1), 1),
                                  (index != 0)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-sm btn-icon btn-light-danger ms-auto",
                                        title: "Xóa mức này",
                                        onClick: ($event: any) => (_ctx.delArrItemAddition(index))
                                      }, _hoisted_173, 8, _hoisted_171))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_174, [
                                  _createElementVNode("div", _hoisted_175, [
                                    _hoisted_176,
                                    _createVNode(_component_el_input, {
                                      modelValue: fill.name,
                                      "onUpdate:modelValue": ($event: any) => ((fill.name) = $event),
                                      class: "form-select-solid w-100",
                                      placeholder: "VD: Đóng từ 4 học kỳ"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_177, [
                                    _hoisted_178,
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      clearable: "",
                                      modelValue: fill.semester,
                                      "onUpdate:modelValue": ($event: any) => ((fill.semester) = $event),
                                      placeholder: "Chọn số học kỳ",
                                      class: "form-select-solid w-100"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptionsSemester, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.code,
                                            label: item.name,
                                            value: item.code
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_179, [
                                    _hoisted_180,
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      clearable: "",
                                      modelValue: fill.type,
                                      "onUpdate:modelValue": ($event: any) => ((fill.type) = $event),
                                      placeholder: "Chọn kiểu giảm",
                                      class: "form-select-solid w-100"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                                                        { code: 'percent', name: 'Theo % (percent)' },
                                                        { code: 'amount', name: 'Theo số tiền (amount)' }
                                                    ], (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.code,
                                            label: item.name,
                                            value: item.code
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_181, [
                                    _hoisted_182,
                                    _createVNode(_component_el_input, {
                                      modelValue: fill.value,
                                      "onUpdate:modelValue": ($event: any) => ((fill.value) = $event),
                                      onKeypress: _cache[37] || (_cache[37] = ($event: any) => (_ctx.isNumber($event))),
                                      placeholder: fill.type == 'percent' ? 'VD: 5' : 'VD: 5.000.000',
                                      onKeyup: e=> {
                                                        if(fill.type == 'amount') {
                                                            fill.value = _ctx.formatCurrentMoney(e,fill.value)
                                                        }
                                                    },
                                      class: "form-select-solid w-100"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onKeyup"])
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.addArrItemAddition && _ctx.addArrItemAddition(...args))),
                          class: "btn btn-sm btn-link d-flex gap-2 align-items-center text-primary"
                        }, [
                          _hoisted_183,
                          _createTextVNode(" Thêm mức ưu đãi ")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_184,
                  _hoisted_185
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}